import { Button } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  margin-bottom: 16px;
`;

export const SelectorsWrapper = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  .ant-checkbox-group {
    display: flex;
    flex-direction: column;
    .ant-checkbox-wrapper {
      margin: 0;
    }
  }
  .ant-select,
  .ant-picker {
    width: 100%;
  }
  .ant-select-selector {
    width: 400px;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.lg}) {
    flex-direction: row;
    align-items: center;
  }
`;

export const ClearSearch = styled(Button)`
  margin-top: 5px;
`;
